/**
 * Checks if a form value is considered empty
 */
export const isEmpty = (value: null | undefined | string | number) =>
  value === null || value === undefined || value === '';
